/**
 * **NOTE** The component in this file is a direct copy of the styles found at:
 * `src/modules/templateEditor/EditPush/`.
 *
 * Like everything else in this module, this work exists under the assumption that it is temporary.
 * We _should_ be using the templateEditor module's preview for this module, but the current template diff
 * module does not fetch its data from grapqhl, a necessity for the templateEdit preview.
 */

import { ChevronDownSmall } from 'ui/icons/navigation/ChevronDownSmall';
import { AndroidPlaceholder } from 'ui/icons/devices/AndroidPlaceholder';
import {
  NotificationBubbleWrapper,
  NotificationBubbleAndroid,
  NotificationAttachmentAndroid,
  NotificationAttachmentWrapper,
  NotificationBubbleAndroidBody,
  NotificationBubbleAndroidBodyContent,
  NotificationBubbleAndroidHeaderTime,
  NotificationBubbleAndroidBodyContentMsg,
  NotificationBubbleAndroidBodyContentMsgTxt,
  NotificationBubbleAndroidBodyContentMsgTitle,
} from './ContentPreviewPush.styled';
import { MAX_CHAR_LIMIT } from './constants';
import { truncateText } from './utils';
import type { TemplateDiffContentPush } from '../../../types';

type NotificationAndroidProps = TemplateDiffContentPush;

export const NotificationAndroid = ({
  title,
  message,
  attachmentUrlAndroid,
}: NotificationAndroidProps) => {
  return (
    <NotificationBubbleWrapper data-test="template-diff-push-preview-android">
      <NotificationBubbleAndroid>
        <NotificationBubbleAndroidHeaderTime>
          <AndroidPlaceholder height={15} width={15} />
          <ChevronDownSmall />
        </NotificationBubbleAndroidHeaderTime>
        <NotificationBubbleAndroidBody>
          <NotificationBubbleAndroidBodyContent>
            <NotificationBubbleAndroidBodyContentMsgTitle>
              {title}
            </NotificationBubbleAndroidBodyContentMsgTitle>
            <NotificationBubbleAndroidBodyContentMsg>
              <NotificationBubbleAndroidBodyContentMsgTxt>
                {truncateText(message, MAX_CHAR_LIMIT.android)}
              </NotificationBubbleAndroidBodyContentMsgTxt>
            </NotificationBubbleAndroidBodyContentMsg>
          </NotificationBubbleAndroidBodyContent>
          {attachmentUrlAndroid && (
            <NotificationAttachmentWrapper data-test="template-diff-push-preview-android-image">
              <NotificationAttachmentAndroid src={attachmentUrlAndroid} alt="Android Push Image" />
            </NotificationAttachmentWrapper>
          )}
        </NotificationBubbleAndroidBody>
      </NotificationBubbleAndroid>
    </NotificationBubbleWrapper>
  );
};
